import { HandHeart, HeartHandshake, House, Sparkles, Star, Wheat } from "lucide-react";

export const values = [
  { title: "Sabor", description: "Receitas que convidam a voltar.", icon: Star },
  { title: "Proximidade", description: "Atendimento atento e familiar.", icon: HeartHandshake },
  { title: "Cuidado", description: "Atenção em cada preparação.", icon: HandHeart },
  { title: "Tradição", description: "Sabores que sabem a casa.", icon: House },
  { title: "Qualidade", description: "Compromisso com produtos bem preparados.", icon: Wheat },
  { title: "Hospitalidade", description: "Uma casa onde é bom entrar.", icon: Sparkles },
] as const;
